<!-- =========================================================================================
  File Name: ScheduleViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ $t('user.schedule.title')}}</h4>
      <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer" ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl" >
  <div class="p-6">
        <!-- <div class="flex">
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div> -->
      <div v-if="ExBox" >
        <label class="vs-select--label w-full">Copy from Schedule Templates</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataSchedule" @input="MakeTemplateSchedule(dataSchedule)" :options="schedules"  />
           <div class="slot-fields" v-for="(date, index) in currrent_schedule.dates" :key="index">
        <br>{{index}}
    <div class="slot-fields" v-for="(item, dayindex) in date" :key="dayindex">
    <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
     <vs-row >
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
    <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="timepicker" name="start_time" placeholder="Start time"/>
   </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
    <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="timepicker" name="end_time" placeholder="End time"/>
    <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span>
   </vs-col>
    </vs-row>
    </div>
    <div  class="slot-actions pr-2 mt-1 " style="float:right;clear: both">
    <vs-button color="primary" size="small" @click="inputAdd(index)"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/></vs-button>
     </div>
        </div>
        </div>
  </div>
   <div class="p-3" v-if="NewBox">
      <!-- NAME -->
        <vs-input :label="$t('user.schedule.schedule_name')" v-model="currrent_schedule.name" class="mt-5 w-full" :name="$t('user.schedule.schedule_name')" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.schedule.schedule_name'))">{{ errors.first($t('user.schedule.schedule_name')) }}</span><br>
      <div class="slot-fields" v-for="(date, index) in currrent_schedule.dates" :key="index">
        <br>{{index}}
    <div class="slot-fields" v-for="(item, dayindex) in date" :key="dayindex">
   <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
   <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="picker" name="start_time" placeholder="Start time"/>
   <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="picker" name="end_time" placeholder="End time"/><span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span>
    </div>
    <div  class="slot-actions pr-2 mt-1 " style="float:right;clear: both">
    <vs-button color="primary" size="small" @click="inputAdd(index)"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/></vs-button>
     </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button  class="mr-6" @click="submitData" :disabled="!isFormValid">{{ $t('common.submit')}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('common.cancel')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import moment from "moment";
import moduleDataList from "@/store/data-list/moduleDataList.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { CREATE_SCHEDULE, UPDATE_SCHEDULE, ALL_SCHEDULE ,CREATE_USER_SCHEDULE} from "@/graphql";
import { UPDATE_USER } from "@/graphql";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
    Datepicker,
    flatPickr,
    moment,
  },
  data() {
    return {
      dataId: null,
      ExBox: true,
      NewBox: false,
      // ViewBox: false,
      dataSchedule:'',
       dataUserSchedule:{
        schedule:{
          scheduledates:{
          }
        }
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      oldSchedule: "",
      previewSchedule:'',
      templateSchedule:'',
      currrent_schedule: {
        id: "",
        name: "",
        dates: {
          Monday: [
            {
              start_time: "",
              end_time: "",
            },
          ],
          Tuesday: [
            {
              start_time: "",
              end_time: "",
            },
          ],
          Wednesday: [
            {
              start_time: "",
              end_time: "",
            },
          ],
          Thursday: [
            {
              start_time: "",
              end_time: "",
            },
          ],
          Friday: [
            {
              start_time: "",
              end_time: "",
            },
          ],
          Saturday: [
            {
              start_time: "",
              end_time: "",
            },
          ],
          Sunday: [
            {
              start_time: "",
              end_time: "",
            },
          ],
        },
      },
      ex_current_schedule:
        {
          dates: {
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: [],
          }
        },
       configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: "H:i",
        time_24hr: false,
        altInput: true,
        dateFormat: "H:i",
      },
      schedules: [],
      ddd:'',
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      }
      else {
        const { id, schedule, students } = JSON.parse(JSON.stringify(this.data));
        this.dataId = id;
        let user_schedule = [];
        for (let i = 0; i < students.length; i++) {
            if (students[i].schedule) {
              for (let j = 0; j < students[i].schedule.scheduledates.length;j++) {
                user_schedule.push(students[i].schedule.scheduledates[j]);
              }
            }
            else {
              for (let j = 0; j < students[i].cameras.length; j++) {
                if (students[i].cameras[j]) {
                  for (let k = 0; k < students[i].cameras[j].schedule.scheduledates.length; k++) {
                    user_schedule.push(students[i].cameras[j].schedule.scheduledates[k]);
                  }
                }
              }
            }
          }
        // console.log(user_schedule)
        this.dataUserSchedule.schedule.scheduledates=user_schedule
        if(schedule){
        this.currrent_schedule.dates= {
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: [],
          }
       var getarry=[]
       for (let i = 0; i <schedule.scheduledates.length; i++) {
        //  delete scheduledates[i].id
          delete schedule.scheduledates[i].__typename
          delete schedule.scheduledates[i].id
          getarry.push(schedule.scheduledates[i])
       }
       for (let i = 0; i < getarry.length; i++) {
          var day = getarry[i].day;
        if(day=="Monday"){
          this.currrent_schedule.dates.Monday.push(getarry[i])
        }
        if(day=="Tuesday"){
          this.currrent_schedule.dates.Tuesday.push(getarry[i])
        }
        if(day=="Wednesday"){
          this.currrent_schedule.dates.Wednesday.push(getarry[i])
        }
        if(day=="Thursday"){
          this.currrent_schedule.dates.Thursday.push(getarry[i])
        }
        if(day=="Friday"){
          this.currrent_schedule.dates.Friday.push(getarry[i])
        }
        if(day=="Saturday"){
          this.currrent_schedule.dates.Saturday.push(getarry[i])
        }
        if(day=="Sunday"){
          this.currrent_schedule.dates.Sunday.push(getarry[i])
        }
       }
      }
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.$validator.reset()
          this.initValues()
        }
      },
    },
    isFormValid() {
      if (this.ExBox) {
        return !this.errors.any() ;
      }
      if (this.NewBox) {
        return !this.errors.any() && this.currrent_schedule.name;
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
      MakeTemplateSchedule(dates){
      var dates=dates.scheduledates
      this.templateSchedule= {
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: [],
          }
        for (let index = 0; index < dates.length; index++) {
             delete dates[index].__typename
             delete dates[index].id
        }
       for (let i = 0; i < dates.length; i++) {
          var day = dates[i].day;
        if(day=="Monday"){
          this.templateSchedule.Monday.push(dates[i])
        }
        if(day=="Tuesday"){
          this.templateSchedule.Tuesday.push(dates[i])
        }
        if(day=="Wednesday"){
          this.templateSchedule.Wednesday.push(dates[i])
        }
        if(day=="Thursday"){
          this.templateSchedule.Thursday.push(dates[i])
        }
        if(day=="Friday"){
          this.templateSchedule.Friday.push(dates[i])
        }
        if(day=="Saturday"){
          this.templateSchedule.Saturday.push(dates[i])
        }
        if(day=="Sunday"){
          this.templateSchedule.Sunday.push(dates[i])
        }
       }
       this.currrent_schedule.dates=this.templateSchedule
    },
      getTime(day,index,start_time,end_time){
          var space="  "
        if(start_time.toString()!='' && end_time.toString()!=''){
            if (end_time > start_time){
              return ""
            }
         else
          {
            return "End Time is Less than Start Time at " + day +  space + (index+1)
          }
        }
      },
    inputAdd(dayindex) {
      var index = this.currrent_schedule.dates[dayindex].length;
      this.currrent_schedule.dates[dayindex].push({
        start_time: "",
        end_time: "",
      });
    },
    inputRemove(index, dayindex) {
      if (this.currrent_schedule.dates[index][dayindex].id) {
        this.deletedschedules.push(
          this.currrent_schedule.dates[index][dayindex].id
        );
      }
      this.currrent_schedule.dates[index].splice(dayindex, 1);
    },
  initValues () {
      this.previewSchedule = '',
      this.ExBox=true
      this.NewBox=false
      this.templateSchedule=''
      this.dataSchedule=''
      this.currrent_schedule=
        {
          "id": "",
          "name": "",
          dates: {
            Monday: [
              {
                "start_time": "",
                "end_time": "",
              }
            ],
            Tuesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
            Wednesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
           Thursday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Friday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Saturday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          Sunday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          }
        }
    },
    oldRemove() {
      this.oldSchedule = "";
      this.$apollo
        .mutate({
          mutation: UPDATE_USER,
          variables: {
            id: this.dataId,
            schedule_id: this.oldSchedule,
          },
        })
        .then((response) => {
          if (response) {
            this.StatusSuccess("Deleted");
            this.initValues();
          }
        })
        .catch((error) => {
          this.StatusFail();
        });
      this.$emit("closeSidebar");
      this.ExBox = true;
      this.NewBox = false;
      // this.ViewBox = true;
      this.initValues();
    },
    StatusSuccess(status) {
      this.$vs.notify({
        title: "Schedule",
        text: this.$t('user.alert_title') +" Schedule" + status + " Successfully!",
        color: "success",
        position: "top-right",
      });
    },
    StatusFail() {
      this.$vs.notify({
        title: "Schedule",
        text: "Schedule assignment failed. Schedule must fall into " + this.$t('student.titlesmall') + ", cameras or location timings.",
        color: "danger",
        position: "top-right",
      });
    },
  CheckCondtion1(scheduleDates){
 ////Condition1: Check if child days exist in parent
        //days of parent
        var parentScheduleDays = [];

        for( let i in this.dataUserSchedule.schedule.scheduledates)
        {
          let element  = this.dataUserSchedule.schedule.scheduledates[i];

          if( element['start_time'] != '' && element['end_time'] != '' ){

                if( parentScheduleDays.indexOf( element["day"] ) == -1 )
                {
                  parentScheduleDays.push( element["day"] );
                }
            }
        }

        //days of child
        var childScheduleDays = [];

        for( let i in scheduleDates )
        {
          let element  = scheduleDates[i];

          for( let j in element )
          {
            // console.log( "element" );
            // console.log( element[j] );

            if( element[j]['start_time'] != '' && element[j]['end_time'] != '' ){

                if( childScheduleDays.indexOf( i ) == -1 )
                {
                  childScheduleDays.push( i );
                }
            }

          }

        }

        // console.log(parentScheduleDays)
        // console.log(childScheduleDays)

        let condition1 = childScheduleDays.filter(d => !parentScheduleDays.includes(d)).length == 0

        let ddd = childScheduleDays.filter(d => !parentScheduleDays.includes(d))
        this.ddd=ddd
        // console.log( 'ddd' )
        // console.log( ddd )


        ////End Condition 1
},

MergeUserScheduleSlots( UserData )
{

  // console.log("UserData=")
  // console.log(UserData)

  //Change location format into nested format

  //let UserData = this.dataLocation.scheduledates

  //Nested format will be assigned to this variable
  let currentFormatSchedule = []

  for ( let i  in UserData.schedule.scheduledates )
  {
    let day = UserData.schedule.scheduledates[i].day

    if( typeof( currentFormatSchedule[day] ) == 'undefined' )
    {
      currentFormatSchedule[day] = []
    }

    currentFormatSchedule[day].push({
      start_time : UserData.schedule.scheduledates[i].start_time,
      end_time: UserData.schedule.scheduledates[i].end_time
    })
  }

  // console.log("currentFormatSchedule=")
  // console.log( currentFormatSchedule )

  // console.log("currentFormatScheduleEND=")

  ////Merge Current Format Slots
  let current_schedule_dates = []

  for( let day in currentFormatSchedule )
  {
    let current_schedule_seconds_slots = []
    current_schedule_dates[day] = []

    for( let j in currentFormatSchedule[day] )
    {

      if(currentFormatSchedule[day][j].start_time !='' && currentFormatSchedule[day][j].end_time !='')
      {
        let  currentSlotStartTimeArray =  currentFormatSchedule[day][j].start_time.split(':');
        let  currentSlotEndTimeArray =  currentFormatSchedule[day][j].end_time.split(':');

        var  currentSlotStartTimeSeconds = parseInt( currentSlotStartTimeArray[0] * 60 * 60 + currentSlotStartTimeArray[1] * 60 ); //current start time seconds
        var  currentSlotEndTimeSeconds = parseInt( currentSlotEndTimeArray[0] * 60 * 60 + currentSlotEndTimeArray[1] * 60 ); //current end time seconds

        for( let s = currentSlotStartTimeSeconds; s<= currentSlotEndTimeSeconds; s += 60 )
        {
          current_schedule_seconds_slots.push( s )
        }

      }
    }

    if( current_schedule_seconds_slots.length > 0 )
    {
      current_schedule_seconds_slots = [...new Set(current_schedule_seconds_slots)].sort(function(a, b){return a - b});

      // console.log(day)
      // console.log(current_schedule_seconds_slots)

      var startTime = current_schedule_seconds_slots[0];
      var endTime = '';

      for(let k in current_schedule_seconds_slots )
      {
        // console.log( current_schedule_seconds_slots[k] )
        // console.log( typeof( current_schedule_seconds_slots[k+1] ) )

        if( typeof( current_schedule_seconds_slots[ parseInt(k)+1] ) == 'undefined' || current_schedule_seconds_slots[ parseInt(k)+1] - current_schedule_seconds_slots[k] != 60 )
        {
          if( startTime != current_schedule_seconds_slots[k] )
          {
            current_schedule_dates[day].push( {
              start_time: startTime,
              end_time: current_schedule_seconds_slots[k]
            } )

            if( typeof( current_schedule_seconds_slots[  parseInt(k)+1] ) != 'undefined' )
            {
              startTime = current_schedule_seconds_slots[parseInt(k)+1]
            }

          }

        }
      }

      //current_schedule_seconds_slots

      //console.log( current_schedule_seconds_slots )
    }
  }


  // console.log( 'current_schedule_dates' )
  // console.log( current_schedule_dates )

  // return

  ////End Merging Current Slots

  return current_schedule_dates
},

MergeCurrentSlot(scheduleDates){
  ////Merge Current Slots

  let current_schedule_dates = []
        for( let day in scheduleDates )
        {
          let current_schedule_seconds_slots = []
          current_schedule_dates[day] = []

          for( let j in scheduleDates[day] )
          {
            if(scheduleDates[day][j].start_time !='' && scheduleDates[day][j].end_time !='')
            {
              let  currentSlotStartTimeArray =  scheduleDates[day][j].start_time.split(':');
              let  currentSlotEndTimeArray =  scheduleDates[day][j].end_time.split(':');

              var  currentSlotStartTimeSeconds = parseInt( currentSlotStartTimeArray[0] * 60 * 60 + currentSlotStartTimeArray[1] * 60 ); //current start time seconds
              var  currentSlotEndTimeSeconds = parseInt( currentSlotEndTimeArray[0] * 60 * 60 + currentSlotEndTimeArray[1] * 60 ); //current end time seconds

              for( let s = currentSlotStartTimeSeconds; s<= currentSlotEndTimeSeconds; s += 60 )
              {
                current_schedule_seconds_slots.push( s )
              }

            }
          }
          if( current_schedule_seconds_slots.length > 0 )
          {
            current_schedule_seconds_slots = [...new Set(current_schedule_seconds_slots)].sort(function(a, b){return a - b});

            // console.log(day)
            // console.log(current_schedule_seconds_slots)

            var startTime = current_schedule_seconds_slots[0];
            var endTime = '';

            for(let k in current_schedule_seconds_slots )
            {
              // console.log( current_schedule_seconds_slots[k] )
              // console.log( typeof( current_schedule_seconds_slots[k+1] ) )

              if( typeof( current_schedule_seconds_slots[ parseInt(k)+1] ) == 'undefined' || current_schedule_seconds_slots[ parseInt(k)+1] - current_schedule_seconds_slots[k] != 60 )
              {
                if( startTime != current_schedule_seconds_slots[k] )
                {
                  current_schedule_dates[day].push( {
                    start_time: startTime,
                    end_time: current_schedule_seconds_slots[k]
                  } )

                  if( typeof( current_schedule_seconds_slots[  parseInt(k)+1] ) != 'undefined' )
                  {
                    startTime = current_schedule_seconds_slots[parseInt(k)+1]
                  }

                }

              }
            }
            //current_schedule_seconds_slots

            //console.log( current_schedule_seconds_slots )
          }
        }


        // console.log( 'current_schedule_dates' )
        // console.log( current_schedule_dates )

        // return

        ////End Merging Current Slots

        this.current_schedule_dates=current_schedule_dates
},
    submitData() {
    var finalschedule=[]
    var scheduledates=''
    if(this.ExBox){
       scheduledates=this.currrent_schedule.dates
    }
    else{
      scheduledates=this.currrent_schedule.dates
    }
      for (let i = 0; i <scheduledates.Monday.length; i++) {
       var element = scheduledates.Monday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {
            element["day"] = "Monday"
            finalschedule.push(element)
          }
    }
    for (let i = 0; i <scheduledates.Tuesday.length; i++) {
       var element = scheduledates.Tuesday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {
              element["day"] = "Tuesday"
              finalschedule.push(element)
          }
      }
    for (let i = 0; i <scheduledates.Wednesday.length; i++) {
       var element = scheduledates.Wednesday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {
                element["day"] = "Wednesday"
                finalschedule.push(element)
          }
    }
    for (let i = 0; i <scheduledates.Thursday.length; i++) {
       var element = scheduledates.Thursday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {
                 element["day"] = "Thursday"
                 finalschedule.push(element)
          }
    }
    for (let i = 0; i <scheduledates.Friday.length; i++) {
       var element = scheduledates.Friday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {
          element["day"] = "Friday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <scheduledates.Saturday.length; i++) {
       var element = scheduledates.Saturday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {
          element["day"] = "Saturday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <scheduledates.Sunday.length; i++) {
       var element = scheduledates.Sunday[i];
      if(element['start_time'] != '' && element['end_time'] != '' )
       {
         element["day"] = "Sunday"
         finalschedule.push(element)
       }
    }
    this.previewSchedule=finalschedule
     var error=0
     checkSchedule(finalschedule);
      function checkSchedule(finalschedule) {
        if (finalschedule.length > 0) {
          for (let i = 0; i < finalschedule.length; i++) {
            if (finalschedule[i].end_time <= finalschedule[i].start_time) {
              error++;
            }
          }
        }
        else {
          error++;
        }
      }
      if (this.ExBox) {
        this.CheckCondtion1(this.currrent_schedule.dates)
        this.MergeCurrentSlot(this.currrent_schedule.dates)
        let userMergedSlots = this.MergeUserScheduleSlots( this.dataUserSchedule )
        // console.log(userMergedSlots)
        //Condition 2: check each slot
        let condition2 = true;
        let totalCurrentSlotSlots = 0;
        let validCurrentSlots = 0;

        for ( let day in this.current_schedule_dates )
        {
          for( let j in this.current_schedule_dates[day] )
          {
            // console.log(this.current_schedule_dates[day][j])

            if(this.current_schedule_dates[day][j].start_time.toString() !='' && this.current_schedule_dates[day][j].end_time !='')
            {
              totalCurrentSlotSlots++;

              let  currentSlotStartTimeSeconds =  this.current_schedule_dates[day][j].start_time;
              let  currentSlotEndTimeSeconds =  this.current_schedule_dates[day][j].end_time;

              for( let i in userMergedSlots[day] )
              {

                if( currentSlotStartTimeSeconds >= userMergedSlots[day][i].start_time && currentSlotEndTimeSeconds <= userMergedSlots[day][i].end_time )
                {
                  validCurrentSlots++;
                  break;
                }
              }

            }
          }
        }
        // console.log( totalCurrentSlotSlots );
        // console.log( validCurrentSlots );
        condition2 = totalCurrentSlotSlots == validCurrentSlots
        // End Condition 2
      if(totalCurrentSlotSlots == validCurrentSlots && this.ddd.length==0 && totalCurrentSlotSlots+validCurrentSlots!==0){
        this.$validator.validateAll().then((result) => {
           if (result && error==0) {

          this.$apollo
          .mutate({
           mutation: CREATE_USER_SCHEDULE,
          variables: {
          id :this.dataId,
          schedule_name:'User'+' '+this.dataId+' '+'Schedule',
          scheduledates: finalschedule
          }
        })
        .then(response => {
          if (response.data.createUserSchedule.status=='SUCCESS'){
          this.StatusSuccess("Created");
          this.$emit("closeSidebar");
          this.initValues();
      }
        }) .catch(error => {
           console.log(error)
        });

                //   this.$apollo
                //  .mutate({
                //   mutation: CREATE_SCHEDULE,
                //   variables: {
                //   name: 'User'+' '+this.dataId+' '+'Schedule',
                //   scheduledates: {
                //       create: finalschedule,
                //     },
                //   },
                // })
                // .then((response) => {
                //   if (response) {
                //   this.$apollo
                //   .mutate({
                //    mutation: UPDATE_USER,
                //    variables: {
                //     id: this.dataId,
                //     schedule_id: response.data.createSchedule.id,
                //     },
                //       })
                //       .then((response) => {
                //         if (response) {
                //           this.StatusSuccess("Created");
                //           this.$emit("closeSidebar");
                //           this.initValues();
                //         }
                //       });
                //   }
                // })
                // .catch((error) => {

                // });
           }

        });
         }
      else{
         this.StatusFail()
      }
      }
      if (this.NewBox) {
        this.CheckCondtion1(this.currrent_schedule.dates)
        this.MergeCurrentSlot(this.currrent_schedule.dates)
        let userMergedSlots = this.MergeUserScheduleSlots( this.dataUserSchedule )
        // console.log(userMergedSlots)
        ////Condition 2: check each slot
        let condition2 = true;
        let totalCurrentSlotSlots = 0;
        let validCurrentSlots = 0;

        for ( let day in this.current_schedule_dates )
        {
          for( let j in this.current_schedule_dates[day] )
          {
            // console.log(this.current_schedule_dates[day][j])

            if(this.current_schedule_dates[day][j].start_time.toString() !='' && this.current_schedule_dates[day][j].end_time !='')
            {
              totalCurrentSlotSlots++;

              let  currentSlotStartTimeSeconds =  this.current_schedule_dates[day][j].start_time;
              let  currentSlotEndTimeSeconds =  this.current_schedule_dates[day][j].end_time;

              for( let i in userMergedSlots[day] )
              {

                if( currentSlotStartTimeSeconds >= userMergedSlots[day][i].start_time && currentSlotEndTimeSeconds <= userMergedSlots[day][i].end_time )
                {
                  validCurrentSlots++;
                  break;
                }
              }

            }
          }
        }
        // console.log( totalCurrentSlotSlots );
        // console.log( validCurrentSlots );
        condition2 = totalCurrentSlotSlots == validCurrentSlots
        //// End Condition 2
     if(totalCurrentSlotSlots == validCurrentSlots && this.ddd.length==0 && totalCurrentSlotSlots+validCurrentSlots!==0){
        var finalschedule = [];
        for (let i = 0; i < this.currrent_schedule.dates.Monday.length; i++) {
          var element = this.currrent_schedule.dates.Monday[i];
          if (element["start_time"] != "" && element["end_time"] != "") {
            element["day"] = "Monday";
            finalschedule.push(element);
          }
        }
        for (let i = 0; i < this.currrent_schedule.dates.Tuesday.length; i++) {
          var element = this.currrent_schedule.dates.Tuesday[i];
          if (element["start_time"] != "" && element["end_time"] != "") {
            element["day"] = "Tuesday";
            finalschedule.push(element);
          }
        }
        for (
          let i = 0;
          i < this.currrent_schedule.dates.Wednesday.length;
          i++
        ) {
          var element = this.currrent_schedule.dates.Wednesday[i];
          if (element["start_time"] != "" && element["end_time"] != "") {
            element["day"] = "Wednesday";
            finalschedule.push(element);
          }
        }
        for (let i = 0; i < this.currrent_schedule.dates.Thursday.length; i++) {
          var element = this.currrent_schedule.dates.Thursday[i];
          if (element["start_time"] != "" && element["end_time"] != "") {
            element["day"] = "Thursday";
            finalschedule.push(element);
          }
        }
        for (let i = 0; i < this.currrent_schedule.dates.Friday.length; i++) {
          var element = this.currrent_schedule.dates.Friday[i];
          if (element["start_time"] != "" && element["end_time"] != "") {
            element["day"] = "Friday";
            finalschedule.push(element);
          }
        }
        for (let i = 0; i < this.currrent_schedule.dates.Saturday.length; i++) {
          var element = this.currrent_schedule.dates.Saturday[i];
          if (element["start_time"] != "" && element["end_time"] != "") {
            element["day"] = "Saturday";
            finalschedule.push(element);
          }
        }
        for (let i = 0; i < this.currrent_schedule.dates.Sunday.length; i++) {
          var element = this.currrent_schedule.dates.Sunday[i];
          if (element["start_time"] != "" && element["end_time"] != "") {
            element["day"] = "Sunday";
            finalschedule.push(element);
          }
        }
             var error=0
             checkSchedule(finalschedule);
              function checkSchedule(finalschedule){
                for (let i = 0; i < finalschedule.length; i++) {
                   if (finalschedule[i].end_time <= finalschedule[i].start_time){
                       error++
                    }
                }
              }
        this.previewSchedule=finalschedule
        this.$validator.validateAll().then((result) => {
          if (result && error==0) {
            if (finalschedule.length > 0) {
              this.$apollo
                .mutate({
                  mutation: CREATE_SCHEDULE,
                  variables: {
                    name: this.currrent_schedule.name,
                    scheduledates: {
                      create: finalschedule,
                    },
                  },
                })
                .then((response) => {
                  if (response) {
                    this.$apollo
                      .mutate({
                        mutation: UPDATE_USER,
                        variables: {
                          id: this.dataId,
                          schedule_id: response.data.createSchedule.id,
                        },
                      })
                      .then((response) => {
                        if (response) {
                          this.StatusSuccess("Created");
                          this.$emit("closeSidebar");
                          this.initValues();
                        }
                      });
                  }
                })
                .catch((error) => {
                  this.StatusFail();
                });
            }
          }
        });
        this.$emit("closeSidebar");
           }
      else{
         this.StatusFail()
      }
      }
    },
    excheck(val) {
      if (val) {
        this.NewBox = !val;
        this.ViewBox = !val;
      } else {
        this.ViewBox = true;
      }
    },
    newcheck(val) {
      if (val) {
        this.ExBox = !val;
        this.ViewBox = !val;
      } else {
        this.ViewBox = true;
      }
    },
  },
  created() {
     this.$apollo
      .mutate({
        mutation: ALL_SCHEDULE,
          variables: {
           status:1
     },
      })

      .then(response => {
        this.schedules=response.data.schedules
      })
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
<style>
.timepicker{
  width: 100%;
}
</style>
